var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import axios from "axios";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { MEETING_ENDPOINTS } from "../../../utils/endpoints";
import { ensureMeetingSubscription } from "../../../utils/meeting-subscription";
import { TeamsMeetingCandidate } from "../../../components/meeting-gui-candidate";
import { messages } from "../../../submodules/Inventory-Module-Types/src/utils/messages";
import { useApplicationContext } from "../../../context/application-context";
import { MEETING_ROUTES } from "../../../constants/routes";
import { useScreenDiscipline } from "../../proctoring/useScreenDiscipline";
import ScreenDisciplineModals from "../../proctoring/ScreenDisciplineModals";
import { UserResultSubmitReason } from "../../../submodules/Assessment-Platform-1.0-Dtos-FE/src/enums/userExamStatus.enum";
import { instructionDataRecoil, isUploaderModalOpenRecoil, } from "../../../atoms/global-state";
import acsRecordingService from "../../../api-client/services/acs-recording-service";
import apiClientServices from "../../../api-client";
import { EndInterviewWarningModal } from "./EndInterviewWarningModal";
import FullscreenEntryModal from "./FullscreenEntryModal";
import { useMeetingTabCloseWarning } from "../useMeetingTabCloseWarning";
const CandidateMeetingUrlBased = () => {
    var _a, _b, _c, _d;
    const navigate = useNavigate();
    const [acsToken, setAcsToken] = useState();
    const [meetingUrl, setMeetingUrl] = useState();
    const [recordingId, setRecordingId] = useState(null);
    const [isEndInterviewModalOpen, setIsEndInterviewModalOpen] = useState(false);
    const [isEndingInterview, setIsEndingInterview] = useState(false);
    const [hasEnteredFullscreen, setHasEnteredFullscreen] = useState(false);
    const { user, tenantSettings } = useApplicationContext();
    const setUploaderModalOpen = useSetRecoilState(isUploaderModalOpenRecoil);
    const colorPalette = (_a = tenantSettings === null || tenantSettings === void 0 ? void 0 : tenantSettings.tenantConfig) === null || _a === void 0 ? void 0 : _a.colorPalette;
    // Memoize userId to prevent unnecessary re-renders of TeamsMeetingCandidate
    const meetingUserId = useMemo(() => ({ communicationUserId: "" }), []);
    // Memoize displayName to prevent unnecessary re-renders
    const displayName = useMemo(() => user.firstName + " " + user.lastName, [user.firstName, user.lastName]);
    const spinnerIndicator = useMemo(() => (_jsx(LoadingOutlined, { style: {
            fontSize: 48,
            color: (colorPalette === null || colorPalette === void 0 ? void 0 : colorPalette.primaryColor) || "#1890ff",
        }, spin: true })), [colorPalette === null || colorPalette === void 0 ? void 0 : colorPalette.primaryColor]);
    const instructionData = useRecoilValue(instructionDataRecoil);
    const allowTabCloseRef = useRef(() => { });
    const screenDiscipline = useScreenDiscipline({
        isEnabled: true,
        isPractice: false,
        submitAssessment: (_event, _reason) => __awaiter(void 0, void 0, void 0, function* () {
            allowTabCloseRef.current();
            const params = new URLSearchParams();
            if (_reason === UserResultSubmitReason.MALPRACTICE_COUNTER_EXCEEDED ||
                _reason === UserResultSubmitReason.PROCTORING_TEST_FAILED) {
                params.set("reason", "cheated");
                if (_reason === UserResultSubmitReason.PROCTORING_TEST_FAILED) {
                    params.set("cheat", "external_device");
                }
                else if (_reason === UserResultSubmitReason.MALPRACTICE_COUNTER_EXCEEDED) {
                    params.set("cheat", "tab_switch");
                }
            }
            else if (_reason === UserResultSubmitReason.TIMEOUT) {
                params.set("reason", "timeout");
            }
            else {
                params.set("reason", "completed");
            }
            navigate(`${MEETING_ROUTES.FINISH_PAGE}?${params.toString()}`);
        }),
    });
    const params = new URLSearchParams(window.location.search);
    const sessionStorageData = sessionStorage.getItem(messages.SESSION_INTERVIEW_META_DATA);
    const interviewMetaData = sessionStorageData
        ? JSON.parse(sessionStorageData)
        : null;
    const accessToken = (_b = interviewMetaData === null || interviewMetaData === void 0 ? void 0 : interviewMetaData.token) !== null && _b !== void 0 ? _b : params.get("ac");
    console.log({ interviewMetaData });
    console.log({ meetingUrl });
    console.log({ accessToken });
    useEffect(() => {
        getMeetingUrl().then(setMeetingUrl);
        getCandidateAccessToken();
    }, []);
    // Start ACS recording when meeting is ready
    useEffect(() => {
        if (acsToken &&
            meetingUrl &&
            (interviewMetaData === null || interviewMetaData === void 0 ? void 0 : interviewMetaData.userId) &&
            (interviewMetaData === null || interviewMetaData === void 0 ? void 0 : interviewMetaData.interviewId) &&
            !recordingId) {
            // startAcsRecording();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        acsToken,
        meetingUrl,
        interviewMetaData === null || interviewMetaData === void 0 ? void 0 : interviewMetaData.userId,
        interviewMetaData === null || interviewMetaData === void 0 ? void 0 : interviewMetaData.interviewId,
    ]);
    const startAcsRecording = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!meetingUrl ||
            !(interviewMetaData === null || interviewMetaData === void 0 ? void 0 : interviewMetaData.userId) ||
            !(interviewMetaData === null || interviewMetaData === void 0 ? void 0 : interviewMetaData.interviewId)) {
            return;
        }
        try {
            const response = yield acsRecordingService.startAcsRecording({
                meetingLink: meetingUrl,
                userId: interviewMetaData.userId,
                interviewId: interviewMetaData.interviewId,
                attemptNumber: interviewMetaData.attemptNum || 1,
                duration: interviewMetaData.duration,
            });
            if (response.status === "started" && response.recordingId) {
                setRecordingId(response.recordingId);
                console.log("ACS recording started:", response.recordingId);
            }
            else {
                console.error("Failed to start ACS recording:", response.message);
            }
        }
        catch (error) {
            console.error("Error starting ACS recording:", error);
        }
    });
    const stopAcsRecording = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!recordingId ||
            !(interviewMetaData === null || interviewMetaData === void 0 ? void 0 : interviewMetaData.userId) ||
            !(interviewMetaData === null || interviewMetaData === void 0 ? void 0 : interviewMetaData.interviewId)) {
            return;
        }
        try {
            const response = yield acsRecordingService.stopAcsRecording({
                recordingId,
                userId: interviewMetaData.userId,
                interviewId: interviewMetaData.interviewId,
                attemptNumber: interviewMetaData.attemptNum || 1,
            });
            if (response.status === "stopped") {
                console.log("ACS recording stopped:", response.recordingId);
                if (response.recordingUrl) {
                    console.log("Recording available at:", response.recordingUrl);
                }
                setRecordingId(null);
            }
            else {
                console.error("Failed to stop ACS recording:", response.message);
            }
        }
        catch (error) {
            console.error("Error stopping ACS recording:", error);
        }
    });
    const getMeetingUrl = () => __awaiter(void 0, void 0, void 0, function* () {
        var _e, _f, _g, _h;
        try {
            if ((interviewMetaData === null || interviewMetaData === void 0 ? void 0 : interviewMetaData.userId) &&
                (interviewMetaData === null || interviewMetaData === void 0 ? void 0 : interviewMetaData.actualStageId) &&
                (interviewMetaData === null || interviewMetaData === void 0 ? void 0 : interviewMetaData.courseId)) {
                const response = yield apiClientServices.get(MEETING_ENDPOINTS.GET_HM_MEETING_LINK, 
                // "http://localhost:7034/hiring-manager/meeting-link",
                {
                    params: Object.assign({ userId: interviewMetaData.userId, stageId: interviewMetaData.actualStageId, courseId: interviewMetaData.courseId }, ((interviewMetaData === null || interviewMetaData === void 0 ? void 0 : interviewMetaData.hmId) && { hmId: interviewMetaData.hmId })),
                });
                if ((_f = (_e = response === null || response === void 0 ? void 0 : response.data) === null || _e === void 0 ? void 0 : _e.result) === null || _f === void 0 ? void 0 : _f.meetLink) {
                    // Create/renew the Graph webhook subscription for this meeting now that
                    // the meeting is being opened, so transcript/recording capture is live
                    // for the session. Fire-and-forget; never blocks joining.
                    const meetingId = (_h = (_g = response === null || response === void 0 ? void 0 : response.data) === null || _g === void 0 ? void 0 : _g.result) === null || _h === void 0 ? void 0 : _h.meetingId;
                    if (meetingId) {
                        void ensureMeetingSubscription(meetingId);
                    }
                    return response.data.result.meetLink;
                }
            }
        }
        catch (error) {
            console.error("Error fetching meeting link from API:", error);
        }
        // Fallback to existing behavior
        return ((interviewMetaData === null || interviewMetaData === void 0 ? void 0 : interviewMetaData.eventLink) ||
            (interviewMetaData === null || interviewMetaData === void 0 ? void 0 : interviewMetaData.meetingLink) ||
            params.get("meeting"));
    });
    const getCandidateAccessToken = () => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield axios({
            method: "GET",
            url: `${MEETING_ENDPOINTS.GET_ACS_TOKEN}`,
            headers: {
                Authorization: "Bearer " + accessToken,
            },
        });
        const data = response === null || response === void 0 ? void 0 : response.data;
        // Backend now returns { token, communicationUserId }; legacy was a bare string.
        const token = typeof data === "string" ? data : data === null || data === void 0 ? void 0 : data.token;
        setAcsToken(token);
    });
    // Use a ref to track fullscreen warning state without causing callback recreation
    const fullscreenWarningOpenRef = useRef(false);
    fullscreenWarningOpenRef.current =
        screenDiscipline.state.fullscreenWarningOpen;
    const handleMeetingEnded = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        // Ignore meeting end if we're not in fullscreen mode
        // (This prevents false end triggers when user exits fullscreen)
        const isInFullscreen = !!document.fullscreenElement;
        if (!isInFullscreen || fullscreenWarningOpenRef.current) {
            console.log("[Meeting] Ignoring meeting end - not in fullscreen or warning is active");
            return;
        }
        // Stop ACS recording before navigating away
        // await stopAcsRecording();
        setIsEndInterviewModalOpen(true);
    }), []); // No dependencies - uses ref for state access
    const handleConfirmEndInterview = () => __awaiter(void 0, void 0, void 0, function* () {
        var _j, _k, _l, _m, _o, _p;
        if (isEndingInterview)
            return;
        try {
            setIsEndingInterview(true);
            // Prepare payload from interviewMetaData
            const payload = Object.assign({ courseId: interviewMetaData === null || interviewMetaData === void 0 ? void 0 : interviewMetaData.courseId, panelInterviewId: (_j = interviewMetaData === null || interviewMetaData === void 0 ? void 0 : interviewMetaData.panelInterviewId) !== null && _j !== void 0 ? _j : interviewMetaData === null || interviewMetaData === void 0 ? void 0 : interviewMetaData.interviewId, panelMemberId: (interviewMetaData === null || interviewMetaData === void 0 ? void 0 : interviewMetaData.hmId)
                    ? Number(interviewMetaData.hmId)
                    : undefined, interviewId: interviewMetaData === null || interviewMetaData === void 0 ? void 0 : interviewMetaData.interviewId, userStageId: interviewMetaData === null || interviewMetaData === void 0 ? void 0 : interviewMetaData.stageId, stageId: interviewMetaData === null || interviewMetaData === void 0 ? void 0 : interviewMetaData.actualStageId }, ((interviewMetaData === null || interviewMetaData === void 0 ? void 0 : interviewMetaData.hmId) && { hmId: interviewMetaData.hmId }));
            console.log("payload in handleConfirmEndInterview:", { payload });
            // Validate required fields
            if (!payload.courseId ||
                !payload.panelInterviewId ||
                !payload.panelMemberId ||
                !payload.userStageId ||
                !payload.stageId) {
                console.error("Missing required fields for ending interview:", payload);
                alert("Error: Missing required information. Please try again.");
                setIsEndingInterview(false);
                return;
            }
            // Call the API
            const response = yield apiClientServices.post(MEETING_ENDPOINTS.END_HM_ROUND, payload);
            if (((_k = response === null || response === void 0 ? void 0 : response.data) === null || _k === void 0 ? void 0 : _k.status) === 200) {
                console.log("HM round ended successfully:", response.data.result);
                setIsEndInterviewModalOpen(false);
                allowTabClose();
                setUploaderModalOpen(true);
                navigate(MEETING_ROUTES.FINISH_PAGE);
            }
            else {
                console.error("Failed to end HM round:", (_l = response === null || response === void 0 ? void 0 : response.data) === null || _l === void 0 ? void 0 : _l.message);
                alert(((_m = response === null || response === void 0 ? void 0 : response.data) === null || _m === void 0 ? void 0 : _m.message) ||
                    "Failed to end interview. Please try again.");
                setIsEndingInterview(false);
            }
        }
        catch (error) {
            console.error("Error ending interview:", error);
            alert(((_p = (_o = error === null || error === void 0 ? void 0 : error.response) === null || _o === void 0 ? void 0 : _o.data) === null || _p === void 0 ? void 0 : _p.message) ||
                "An error occurred while ending the interview. Please try again.");
            setIsEndingInterview(false);
        }
    });
    const handleCancelEndInterview = () => {
        setIsEndInterviewModalOpen(false);
    };
    // Handler for entering fullscreen mode (triggered by user click)
    const handleEnterFullscreen = () => __awaiter(void 0, void 0, void 0, function* () {
        yield screenDiscipline.actions.enterFullscreen();
        setHasEnteredFullscreen(true);
    });
    // Check if all data is ready for the meeting
    const isMeetingDataReady = acsToken && meetingUrl && (interviewMetaData === null || interviewMetaData === void 0 ? void 0 : interviewMetaData.userId);
    const isMeetingInProgress = Boolean(isMeetingDataReady && hasEnteredFullscreen && !isEndingInterview);
    const { allowTabClose } = useMeetingTabCloseWarning(isMeetingInProgress);
    allowTabCloseRef.current = allowTabClose;
    console.log({ isMeetingDataReady });
    console.log({ hasEnteredFullscreen });
    // Show fullscreen entry modal when data is ready but user hasn't entered fullscreen
    const showFullscreenEntryModal = isMeetingDataReady && !hasEnteredFullscreen;
    return (_jsxs("div", Object.assign({ style: { overflow: "hidden", position: "relative" } }, { children: [_jsx(ScreenDisciplineModals, { state: screenDiscipline.state, actions: screenDiscipline.actions, tenantColors: {
                    dangerColor: ((_d = (_c = tenantSettings === null || tenantSettings === void 0 ? void 0 : tenantSettings.tenantConfig) === null || _c === void 0 ? void 0 : _c.colorPalette) === null || _d === void 0 ? void 0 : _d.dangerColor) ||
                        "#ff4d4f",
                } }), _jsx(FullscreenEntryModal, { visible: showFullscreenEntryModal, onEnterFullscreen: handleEnterFullscreen, primaryColor: colorPalette === null || colorPalette === void 0 ? void 0 : colorPalette.primaryColor }), isMeetingDataReady && hasEnteredFullscreen ? (_jsx(TeamsMeetingCandidate, { token: acsToken, userId: meetingUserId, displayName: displayName, callInvitationURL: meetingUrl, locator: meetingUrl, onMeetingEnd: handleMeetingEnded })) : (_jsx("div", Object.assign({ style: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "89vh",
                } }, { children: _jsx(Spin, { size: "large", indicator: spinnerIndicator }) }))), _jsx(EndInterviewWarningModal, { visible: isEndInterviewModalOpen, onConfirm: handleConfirmEndInterview, onCancel: handleCancelEndInterview, loading: isEndingInterview })] })));
};
export default CandidateMeetingUrlBased;
